import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import * as H from "history";
import React, { FC, Suspense } from "react";
import { Router } from "react-router-dom";

import DataGridSelectionProvider from "components/DataGrid/DataGridSelectionProvider";
import GlobalErrorBoundary from "components/providers/GlobalErrorBoundary";
import theme from "theme";

import ReactQueryProvider from "./components/providers/ReactQueryProvider";
import SEOProvider from "./components/providers/SEOProvider";
import SplashScreenProvider from "./components/providers/SplashScreenProvider";
import ToastProvider from "./components/providers/ToastProvider";

const Providers: FC<{ history: H.History }> = ({ children, history }) => {
  return (
    <>
      <CssBaseline />
      <ThemeProvider theme={theme}>
        <SEOProvider />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <GlobalErrorBoundary>
            <SplashScreenProvider>
              <Suspense fallback={<></>}>
                <Router history={history}>
                  <ToastProvider>
                    <ReactQueryProvider>
                      <DataGridSelectionProvider>
                        {children}
                      </DataGridSelectionProvider>
                    </ReactQueryProvider>
                  </ToastProvider>
                </Router>
              </Suspense>
            </SplashScreenProvider>
          </GlobalErrorBoundary>
        </LocalizationProvider>
      </ThemeProvider>
    </>
  );
};

export default Providers;
